import React, {useEffect, useMemo} from 'react';
import {MeshType} from 'api/generated';
import {Mesh} from 'three';
import {useGLTF} from '@react-three/drei';

interface IARModelGLB {
  data: MeshType;
  onLoad?: () => void;
}

const ARModelGLB = (props: IARModelGLB) => {
  const {data, onLoad} = props;
  const glb = useGLTF(data.fileUrl!);
  const object = useMemo(() => glb.scene.clone(), [glb]);

  useEffect(() => {
    object.traverse(o => {
      if ((o as Mesh).isMesh) {
        o.castShadow = true;
      }
    });
    onLoad?.();
  }, [object]);

  return <primitive object={object} />;
};

export default React.memo(ARModelGLB);
